// utils/fetchStatsAndDownloads.js
import { supabase } from "../supabaseClient";

export const fetchStatsAndDownloads = async (
  user,
  setStats,
  setDownloadHistory,
  setUsedToday
) => {
  const today = new Date().toISOString().split("T")[0];

  const { data: statsData, error: statsError } = await supabase
    .from("user_stats")
    .select("*")
    .eq("id", user.id)
    .single();

  if (statsError || !statsData) {
    console.error("Stats error:", statsError?.message);
    return;
  }

  // Reset daily_remaining if it's a new day
  const lastUpdated = statsData.last_updated?.split("T")[0];
  if (lastUpdated !== today) {
    const updatedStats = {
      daily_remaining: statsData.daily_limit,
      last_updated: today,
    };

    const { error: updateErr } = await supabase
      .from("user_stats")
      .update(updatedStats)
      .eq("id", user.id);

    if (updateErr) {
      console.error("Error updating daily reset:", updateErr.message);
    } else {
      statsData.daily_remaining = statsData.daily_limit;
      statsData.last_updated = today;
    }
  }

  setStats(statsData);

  // Fetch download history
  const { data: history, error: historyError } = await supabase
    .from("downloads")
    .select("*")
    .eq("user_id", user.id)
    .order("created_at", { ascending: false });

  if (historyError) {
    console.error("Error fetching history:", historyError.message);
  } else {
    setDownloadHistory(history);
  }

  // Calculate used today from stats
  const usedToday = statsData.daily_limit - statsData.daily_remaining;
  setUsedToday(usedToday);
};
